import { useParams } from "react-router-dom";

import { UpdateBannerPayload } from "~/api/banner.types";
import { BannerFormModal } from "~/screens/Admins/banner-management/banner-form-modal";
import {
  useGetBanner,
  useUpdateBanner,
} from "~/screens/Admins/banner-management/hooks/use-banner-admin";
import { usePermissions } from "~/screens/Admins/hooks/usePermissions";
import type { ModalProps } from "~/shared.types";

export const BannerDetailsModal = ({ show, onClose }: ModalProps) => {
  const { bannerId } = useParams<{ bannerId: string }>();
  const { canManageBanners } = usePermissions();
  const { data: banner } = useGetBanner(bannerId);
  const updateMutation = useUpdateBanner();

  if (!bannerId || !banner) return null;

  return (
    <BannerFormModal
      show={show}
      banner={banner}
      readOnly={!canManageBanners}
      onClose={onClose}
      onSubmit={(data) =>
        updateMutation.mutate(
          { id: bannerId, data: data as UpdateBannerPayload },
          { onSuccess: onClose },
        )
      }
      isLoading={updateMutation.isPending}
    />
  );
};
